import { FunctionComponent } from 'react';
import { changeLanguage } from 'i18next';
import { Modal, Button, Image } from 'react-bootstrap';
import './LanguageSelectionModal.scss';
import LoaderButton from '../../../components/common/LoaderButton';
import languageIcon from '../../../assets/images/icons/language-modal-x3.png';

interface LanguageSelectionModalProps {
  show: boolean;
  onHide: () => void;
}

const LanguageSelectionModal: FunctionComponent<LanguageSelectionModalProps> = ({
  show,
  onHide,
}) => {
  const handleLanguageChange = (language: string) => {
    changeLanguage(language);
    localStorage.setItem('@language', language);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className='language-selection-modal'>
      <Modal.Header closeButton className='flex-column align-items-start'>
        <div className='w-100 d-flex justify-content-between align-items-center mb-3'>
          <Image src={languageIcon} alt='Language Icon' className='language-icon' />
        </div>
        <Modal.Title>
          <h2 className='mt-2'>Navigate in Spanish.</h2>
          <h2>Navegar en Español.</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Good news! Direct2Care now speaks your language. We&apos;ve added the ability to switch
          between English and Spanish, making your experience more personalized and comfortable.
        </p>
        <p>
          ¡Buenas noticias! Direct2Care ahora habla tu idioma. Agregamos la capacidad de cambiar
          entre inglés y español, haciendo tu experiencia más personalizada y cómoda.,
        </p>
      </Modal.Body>
      <Modal.Footer>
        <LoaderButton onClick={() => handleLanguageChange('es')}>Cambiar idioma</LoaderButton>
        <Button
          variant={'secondary'}
          className='language-selection-confirm-btn'
          onClick={() => handleLanguageChange('en')}
        >
          No, keep current language
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LanguageSelectionModal;
